import { LifeInsuranceType } from '/@/modules/asset/enums/LifeInsuranceType';
import Lang from '/@/modules/core/app/services/Lang';

export class LifeInsuranceAssetMeta {
  /**
   * @var {string}
   */
  lifeInsuranceProviderId;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  plan;

  /**
   * @var {string}
   */
  policyNumber;

  /**
   * @var {number}
   */
  sharePercentage;

  /**
   * @var object
   */
  provider;

  constructor(model = {}) {
    this.lifeInsuranceProviderId = model.lifeInsuranceProviderId;
    this.provider = model.provider;
    this.type = model.type;
    this.plan = model.plan;
    this.policyNumber = model.policyNumber;
    this.sharePercentage = model.sharePercentage;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return `${this.policyNumber} - ${LifeInsuranceType.getByKey(this.type)?.value} ${Lang.t(
      'asset.32247963-8364-47e2-8adf-dcd923cf3dcb'
    )}`;
  }
}
